import { cn } from '@/lib/utils';
import { LIKERT_OPTIONS } from '@/lib/inventory-types';

interface LikertScaleProps {
  value: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function LikertScale({ value, onChange, disabled }: LikertScaleProps) {
  return (
    <div className="space-y-4">
      {/* Desktop layout */}
      <div className="hidden sm:flex justify-between gap-2">
        {LIKERT_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            disabled={disabled}
            className={cn(
              'flex-1 py-4 px-2 rounded-xl text-sm font-medium transition-all duration-200',
              'border-2 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
              value === option.value
                ? cn(option.color, 'text-white border-transparent shadow-lg scale-105')
                : 'bg-white border-border text-muted-foreground hover:border-primary/50',
              disabled && 'opacity-50 cursor-not-allowed hover:scale-100'
            )}
          >
            <span className="block text-xs leading-tight">{option.label}</span>
          </button>
        ))}
      </div>

      {/* Mobile layout - stacked */}
      <div className="sm:hidden space-y-2">
        {LIKERT_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            disabled={disabled}
            className={cn(
              'w-full py-3 px-4 rounded-xl text-sm font-medium transition-all duration-200',
              'border-2 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
              value === option.value
                ? cn(option.color, 'text-white border-transparent shadow-lg')
                : 'bg-white border-border text-muted-foreground hover:border-primary/50',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>

      {/* Legend for desktop */}
      <div className="hidden sm:flex justify-between text-xs text-muted-foreground px-1">
        <span>Strongly disagree</span>
        <span>Strongly agree</span>
      </div>
    </div>
  );
}
